import { apiSlice } from './apiSlice'
import { getDeviceId } from '../../config/firebase'

export const guestApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Guest Session Management
    createGuestSession: builder.mutation({
      // deviceId lets the backend tell "same guest, second phone" apart from
      // "next occupant of this room". Without it, an unrecognised device that
      // scans a room's QR code can inherit the previous guest's session.
      query: ({ hotelId, roomId }) => ({
        url: '/guest/session',
        method: 'POST',
        body: { hotelId, roomId, deviceId: getDeviceId() },
      }),
      invalidatesTags: ['Session'],
    }),

    // Confirms with the server that the session we have cached locally is still
    // live. Called on boot so a session ended server-side (checkout, staff
    // action) doesn't keep working in the UI until an unrelated request fails.
    getCurrentSession: builder.query({
      query: () => ({
        url: '/guest/session/me',
        method: 'GET',
      }),
      providesTags: ['Session'],
    }),

    // Tells the backend the guest is done, so it can revoke push tokens and
    // clear carts instead of leaving the session live until its timer runs out.
    endGuestSession: builder.mutation({
      query: () => ({
        url: '/guest/session/end',
        method: 'POST',
      }),
      invalidatesTags: ['Session'],
    }),
  }),
})

export const {
  useCreateGuestSessionMutation,
  useGetCurrentSessionQuery,
  useLazyGetCurrentSessionQuery,
  useEndGuestSessionMutation,
} = guestApi
